import { Table } from "../../components/Table";
import { cellStyle } from "../../components/Table/Table.styles";
import { TitleLink } from "./MetricsAndReports.styles";

const iFrameParams =
  "?embed_domain=https:%2F%2Fmpactwork.com&apply_formatting=true&apply_viz=true&show_title=false";
const baseRoute = "./metrics";

const reports = [
  {
    label: "Agreement Conversions Funnel",
    link: `${baseRoute}/agreementConversionsFunnel`,
    iframe:
      "https://milestone.cloud.looker.com/embed/public/looks/KDP5J5Q8xkc7w4xtgSZDd88hNpthJWtp" +
      iFrameParams,
  },
  {
    label: "Another Report",
    link: `${baseRoute}/agreementConversionsFunnel`,
    iframe:
      "https://milestone.cloud.looker.com/embed/public/looks/KDP5J5Q8xkc7w4xtgSZDd88hNpthJWtp" +
      iFrameParams,
  },
  {
    label: "Number of Things Worked",
    link: `${baseRoute}/agreementConversionsFunnel`,
    iframe:
      "https://milestone.cloud.looker.com/embed/public/looks/KDP5J5Q8xkc7w4xtgSZDd88hNpthJWtp" +
      iFrameParams,
  },
  {
    label: "Something Metrics",
    link: `${baseRoute}/agreementConversionsFunnel`,
    iframe:
      "https://milestone.cloud.looker.com/embed/public/looks/KDP5J5Q8xkc7w4xtgSZDd88hNpthJWtp" +
      iFrameParams,
  },
  {
    label:
      "Report with a really really really really really long name or something",
    link: `${baseRoute}/agreementConversionsFunnel`,
    iframe:
      "https://milestone.cloud.looker.com/embed/public/looks/KDP5J5Q8xkc7w4xtgSZDd88hNpthJWtp" +
      iFrameParams,
  },
];

export const getColumns = () => {
  return [
    {
      title: "Report Name",
      field: "label",
      align: "left",
      searchable: true,
      cellStyle: cellStyle,
      render: (report: any) => {
        return <TitleLink to={report.link}>{report.label}</TitleLink>;
      },
    },
  ];
};

export const MetricsAndReports = () => {
  return (
    <div style={{ display: "flex", placeContent: "center" }}>
      <Table
        data={reports}
        columns={getColumns()}
        isLoading={false}
        defaultRows={10}
        searchable
        rowsPerPage={[10, 20, 35, 50]}
      />
    </div>
  );
};
